<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 col-lg-9 mx-auto">
        <div class="card bg-gradient-primary overflow-hidden mb-4">
          <div class="card-body position-relative py-4">
            <span class="hero-glow"></span>
            <div class="row align-items-center position-relative">
              <div class="col-auto">
                <div class="icon icon-shape icon-lg bg-white shadow text-center border-radius-lg">
                  <i class="ni ni-money-coins text-dark opacity-10" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col">
                <h5 class="text-white mb-0">Setting Potongan</h5>
                <p class="text-white text-sm opacity-8 mb-0">
                  Atur tarif potongan keterlambatan, pulang cepat, dan alpa. Otomatis terhitung dan masuk ke Slip Gaji (web &amp; mobile).
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="alert-info-box mb-4">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
              Isi 0 pada tarif yang tidak ingin dipotong. Selama tarif masih 0, tidak ada potongan yang diterapkan ke slip gaji siapa pun.
            </div>

            <!-- Per Menit Telat -->
            <div class="potongan-row">
              <div class="icon icon-shape icon-sm bg-gradient-warning shadow text-center border-radius-md">
                <i class="ni ni-watch-time text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <label class="form-control-label mb-1">Potongan Telat Masuk (per menit)</label>
                <div class="input-group">
                  <span class="input-group-text">Rp</span>
                  <input type="number" min="0" class="form-control" v-model.number="data.potongan_per_menit_telat">
                  <span class="input-group-text">/ menit</span>
                </div>
                <p class="text-xs text-secondary mt-1 mb-0">
                  Contoh: telat 30 menit = <strong>{{ convertRp(30 * (data.potongan_per_menit_telat || 0)) }}</strong>
                </p>
              </div>
            </div>

            <hr class="horizontal dark my-4">

            <!-- Per Jam Pulang Cepat -->
            <div class="potongan-row">
              <div class="icon icon-shape icon-sm bg-gradient-info shadow text-center border-radius-md">
                <i class="ni ni-curved-next text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <label class="form-control-label mb-1">Potongan Pulang Cepat (per jam)</label>
                <div class="input-group">
                  <span class="input-group-text">Rp</span>
                  <input type="number" min="0" class="form-control" v-model.number="data.potongan_per_jam_pulang_cepat">
                  <span class="input-group-text">/ jam</span>
                </div>
                <p class="text-xs text-secondary mt-1 mb-0">
                  Contoh: pulang cepat 2 jam = <strong>{{ convertRp(2 * (data.potongan_per_jam_pulang_cepat || 0)) }}</strong>
                </p>
              </div>
            </div>

            <hr class="horizontal dark my-4">

            <!-- Per Hari Alpa -->
            <div class="potongan-row">
              <div class="icon icon-shape icon-sm bg-gradient-danger shadow text-center border-radius-md">
                <i class="ni ni-fat-remove text-white opacity-10 text-xs" aria-hidden="true"></i>
              </div>
              <div class="flex-grow-1">
                <label class="form-control-label mb-1">Potongan Alpa / Tidak Masuk (per hari)</label>
                <div class="input-group">
                  <span class="input-group-text">Rp</span>
                  <input type="number" min="0" class="form-control" v-model.number="data.potongan_per_hari_alpa">
                  <span class="input-group-text">/ hari</span>
                </div>
                <p class="text-xs text-secondary mt-1 mb-0">
                  Contoh: 3 hari alpa = <strong>{{ convertRp(3 * (data.potongan_per_hari_alpa || 0)) }}</strong>
                </p>
              </div>
            </div>

            <div class="text-end mt-4">
              <argon-button variant="gradient" color="success" size="sm" @click="save()">
                <i class="fa fa-save fa-sm" aria-hidden="true"></i> Simpan
              </argon-button>
            </div>

            <p class="text-xs text-secondary mt-3 mb-0" v-if="data.updated_at">
              Terakhir diubah {{ moment(data.updated_at).locale('id').format('D MMMM YYYY, HH:mm') }}<span v-if="data.updated_by"> oleh {{ data.updated_by }}</span>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import settingPotongan from '@/services/settingPotongan.service';
import akun from '@/services/akun.service';
import moment from 'moment';

export default {
  name: "setting-potongan",
  components: {
    ArgonButton,
  },
  data() {
    return {
      data: {
        potongan_per_menit_telat: 0,
        potongan_per_jam_pulang_cepat: 0,
        potongan_per_hari_alpa: 0,
      },
    };
  },
  mounted() {
    this.get();
    this.getRole();
  },
  methods: {
    moment,
    convertRp(value) {
      return 'Rp ' + Math.round(value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    get() {
      let context = this;
      Api(context, settingPotongan.show()).onSuccess(function(response) {
        if (response.data.data) {
          context.data = response.data.data;
        }
      }).onError(function() {
        context.notify('Gagal memuat setting potongan', 'error')
      })
      .call()
    },
    getRole() {
      let context = this;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
        if (response.data.data[0].role != 'Admin') {
          context.$router.push({ path: '/detail-profile/'+response.data.data[0].employee_id})
        }
      }).onError(function(error) {})
      .call()
    },
    save() {
      let context = this;

      const payload = {
        potongan_per_menit_telat: context.data.potongan_per_menit_telat || 0,
        potongan_per_jam_pulang_cepat: context.data.potongan_per_jam_pulang_cepat || 0,
        potongan_per_hari_alpa: context.data.potongan_per_hari_alpa || 0,
      };

      Api(context, settingPotongan.update(payload)).onSuccess(function(response) {
        context.data = response.data.data;
        context.notify('Setting Potongan Berhasil Disimpan', 'success')
      }).onError(function() {
        context.notify('Gagal menyimpan setting potongan', 'error')
      })
      .call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { autoClose: 2000 });
      } else {
        toast.error(message, { autoClose: 2000 });
      }
    },
  }
};
</script>
<style scoped>
.hero-glow {
  position: absolute;
  top: -60px;
  right: -60px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0) 70%);
  pointer-events: none;
}
.icon-sm {
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
}
.potongan-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.alert-info-box {
  background-color: #e8f4fd;
  color: #0b5a8a;
  border-radius: 0.75rem;
  padding: 12px 16px;
  font-size: 0.8rem;
}
.alert-info-box i {
  margin-right: 6px;
}
</style>
